import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@mui/material';
import useFeedbackHandler from 'hooks/useFeedbackHandler';
import store from 'store';

import DownloadIcon from '@common/assets/icons/Download.svg';
import { downloadFileByUrl } from '@common/helpers/downloadFile';
import { IStudentProgramModel } from '@common/models/StudentPrograms/StudentProgram';

import * as Styled from './styled';

interface PropsType {
	programModel: IStudentProgramModel;
	isTalented?: boolean;
}

function ProgramCertificateButton({ programModel, isTalented }: PropsType) {
	const { t } = useTranslation();

	const isDisabled = isTalented
		? programModel.loading || !programModel.talentedFinalPdf?.url
		: programModel.certificateGenerating || !programModel.is_able_get_certificate;

	const handleFeedback = useFeedbackHandler();

	const handleGenerateCertificate = async () => {
		await handleFeedback(() =>
			isTalented && programModel.talentedFinalPdf?.url
				? downloadFileByUrl(programModel.talentedFinalPdf?.url)
				: programModel.generateCertificate({ student_id: store.currentStudentId }),
		);
	};

	return (
		<Tooltip
			title={
				programModel.is_able_get_certificate || programModel.talentedFinalPdf?.url
					? ''
					: t('program.certificateToolTip')
			}
		>
			<span>
				<Styled.Button
					startIcon={<DownloadIcon style={{ width: '24px', height: '24px' }} />}
					variant="contained"
					color="primary"
					disabled={isDisabled}
					onClick={handleGenerateCertificate}
				>
					{isTalented ? t('program.professionalPathDownload') : t('program.certificateDownload')}
				</Styled.Button>
			</span>
		</Tooltip>
	);
}

export default observer(ProgramCertificateButton);
